export default "__VITE_ASSET__f1cc5bab__"